
<template>
  <div class="user-manager" @keyup.enter="enterSearch">
    <el-form class="table-search-bar maintain-form" inline ref="form" :model="form" label-width="70px">
    <el-form-item label="类型" prop="type">
        <el-select v-model="form.type" placeholder="请选择">
          <el-option
            v-for="item in typeArr"
            :key="item.id"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
     <el-form-item label="模板标题" prop="templateName">
        <el-input v-model="form.templateName" placeholder="请输入用户手机"></el-input>
      </el-form-item>
         <!--
      <el-form-item label="通知时间" prop="createTime">
        <el-date-picker
          popper-class="picktime-box"
          v-model="form.time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :clearable="false">
        </el-date-picker>
     </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="data"
      tooltip-effect="light"
      ref="multipleTable"
      style="width: 100%">
      <el-table-column
        prop="id"
        label="外呼模板编号"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        label="消息类型"
        :show-overflow-tooltip="true">
        <template slot-scope="scope">{{ handleType(scope.row.templateCode) }}</template>
      </el-table-column>
      <el-table-column
        prop="templateName"
        label="模板标题"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column
        prop="content"
        label="模板内容"
        :show-overflow-tooltip="true">
      </el-table-column>
      <el-table-column label="是否通知到指定群" width="210">
        <template slot-scope="scope">
          <el-button
          v-if="handleType(scope.row.templateCode) === '语音'"
             @click="handlesStatus(scope.row)"
            v-permission="'0010405'"
            size="mini">{{ scope.row.sendDd === 1 ? '关闭' : '开启' }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="listState.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listState.total"
      :current-page="listState.pageNo"
      background>
    </el-pagination>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  name: 'callTemplateManager',
  data () {
    return {
      typeArr: [
        { value: '', label: '全部' },
        { value: 'SMS', label: '短信' },
        { value: 'TTS', label: '语音' }],
      form: {
        type: '',
        templateName: ''
      }
    }
  },
  computed: {
    ...mapState({
      data: state => state.callTemplateManager.list,
      listState: state => state.callTemplateManager.listState
    })
  },
  methods: {
    ...mapActions(['getCallTemplateList', 'changeTemplateStatus']),
    enterSearch (e) { // 回车搜索
      if (e.target.form && e.target.nodeName === 'INPUT') {
        this.handleSearch()
      }
    },
    // 搜索
    handleSearch () {
      const params = {
        ...this.form,
        pageNo: 1
      }
      console.log(this.form)
      this.getCallTemplateList(params)
    },
    // 重置
    handleReset () {
      this.$refs['form'].resetFields()
      this.handleSearch()
    },
    handleSizeChange (val) {
      this.getCallTemplateList({ pageNo: 1, pageSize: val })
    },
    handleCurrentChange (val) {
      this.getCallTemplateList({ pageNo: val })
    },
    handleType (val) {
      if (val.includes('SMS')) {
        return '短信'
      } else if (val.includes('TTS')) {
        return '语音'
      }
      return '-'
    },
    handlesStatus (row) {
      this.$confirm('是否确认操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.changeTemplateStatus({ id: row.id, status: row.sendDd === 1 ? 0 : 1 }).then(() => {
          this.$message({
            type: 'success',
            message: '操作成功!'
          })
          this.handleSearch()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    }
  },
  mounted () {
    this.handleSearch()
  }
}
</script>

<style lang="scss" scoped>
.line {
  margin-top: 15px;
}
</style>
